

<div class="container ">
  <div class="row">
    <div class="col-12 booking-section white-bg containerbdr">
      <div class="possticky booking-section">
        <div class="row">
          <div class="step-section">
            <ul class="lst2">
              <li *ngFor="let step of steps" [ngClass]="{active: step.isCompleted, selected: step.isActive}">
                <div class="staplink">
                  <span class="circle"><em [class]="step.iconClass"></em></span>
                </div>
                <span class="steptext">{{step.iconName | translate}}</span>
              </li>
            </ul>
          </div>
          <div class="step-section timer" *ngIf="commonService.expirationTimer > 0">
            {{commonService.secondsToTime(commonService.expirationTimer)}}
          </div>
        </div>
      </div>
      <div class="pos-relative row p-30">
        <div class="cst-col-12 xscol-100 nopdlr">
          <div class="accmain-container"></div>
          <ngb-accordion class="acc-container overflow-none-card" [closeOthers]="true" [activeIds]="activeIds">
              <!-- After Completed add this class "value-selected"  -->
            <ngb-panel *ngFor="let panel of panels;" [cardClass]="panel.isActive?'active':''" [id]="panel.panelId">
              <ng-template ngbPanelHeader>
                <div class="acc-section" [ngClass]="{'value-selected': panel.isCompleted}">
                  <div class="acc-title" (click)="tryOpeningPanel(panel.panelId)">
                    <div class="inner flex-center space-between">
                      <em class="cmn-icn-2x icn-filled mrt15"></em>
                      <div class="flex-grow dflex">
                       {{panel.Title  | translate}}
                        <span *ngIf="panel.selectedValue" >{{ panel.selectedValue }} </span>
                      </div>
                      <em class="acc-arrow"></em>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <div class="acc-section" [ngClass]="{'active': panel.isActive, 'completed': panel.isCompleted}"
                  *ngIf="panel.panelId === panelIds.Panel1">
                  <app-find-car (openAnotherPanelRequest)="tryOpeningPanel($event)"></app-find-car>
                </div>
                <div class="acc-section" [ngClass]="{'active': panel.isActive, 'completed': panel.isCompleted}"
                  *ngIf="panel.panelId === panelIds.Panel2">
                  <app-select-services (openAnotherPanelRequest)="tryOpeningPanel($event)"></app-select-services>
                </div>
                <div class="acc-section" [ngClass]="{'active': panel.isActive, 'completed': panel.isCompleted}"
                  *ngIf="panel.panelId === panelIds.Panel3">
                  <app-select-workshop (openAnotherPanelRequest)="tryOpeningPanel($event)"></app-select-workshop>
                </div>
                <div class="acc-section" [ngClass]="{'active': panel.isActive, 'completed': panel.isCompleted}"
                  *ngIf="panel.panelId === panelIds.Panel4">
                  <app-additional-services (openAnotherPanelRequest)="tryOpeningPanel($event)"></app-additional-services>
                </div>
                <div class="acc-section" [ngClass]="{'active': panel.isActive, 'completed': panel.isCompleted}"
                  *ngIf="panel.panelId === panelIds.Panel5">
                  <app-contact (openAnotherPanelRequest)="tryOpeningPanel($event)"></app-contact>
                </div>
              </ng-template>
            </ngb-panel>
    
          </ngb-accordion>
        </div>
      </div>
    </div>
  </div>
</div>